export class SummitAuthService {
  isLoggedIn(): boolean{return false}
  logout() {return;}
}
